import { AppDispatch, RootState } from '@/app-storage/store.ts'
import LoadingCard from '@/common/components/LoadingCard.tsx'
import { ChildrenProp } from '@/common/types_and_interfaces.ts'

import { FetchProgramSettings } from '@/app-storage/program_settings/thunks.ts'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider.tsx'
import { Button } from '@/common/components/Button.tsx'
import { FullCenteredMain } from '@/layouts/FullCenteredLayout.tsx'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useSignOut } from '../common/hooks/useSignOut'

export function ProgramSettingsService({ children }: ChildrenProp) {
  const { t: translate } = useTranslation()
  const signOut = useSignOut()
  const Dispatcher = useDispatch<AppDispatch>()
  const settings = useSelector((state: RootState) => state.ProgramSettings)
  const { selectedProgramId } = useApplicantProgramYears()
  useEffect(() => {
    Dispatcher(FetchProgramSettings(selectedProgramId))
  }, [selectedProgramId])


  if (!settings.data || settings.request.status === 'in_flight') {
    return (
      <FullCenteredMain>
        <LoadingCard isLoading={true}>
          <span>{translate('loading_program_settings')}</span>
        </LoadingCard>
      </FullCenteredMain>
    )
  }

  if (settings.request.status === 'failed') {
    return (
      <>
        <FullCenteredMain>
          <LoadingCard>
            <span className="mb-2">
              {translate('unable_to_retrieve_settings')}
            </span>
            <p className="mb-14 text-base text-gray-500 font-normal">
              {translate('signed_out_title')}
            </p>
            <Button
              size="lg"
              onClick={() => {
                signOut()
              }}
            >
              {translate('back_to_login')}
            </Button>
          </LoadingCard>
        </FullCenteredMain>
      </>
    )
  }

  return children
}
